const signup = {
  invalidToken: 'Ficha de convite inválida. Por favor, verifique o link ou solicite um novo convite.',
  invitationAccepted: 'Convite aceito com sucesso. Bem-vindo a bordo!',
  unknownError: 'Ops! Algo correu mal.',
  conflictEmailOrPhone: 'O e-mail ou número de telefone já está em uso por outro moderador',
  signupTitle: 'Faça parte da sua equipe!',
  submitBtn: 'Acesse agora',
  signupSuccessful: 'Você se inscreveu com sucesso no Optibus Shuttles!',
  signupFailed: 'Algo correu mal. Por favor, tente novamente ou entre em contato com michael@moovex.com',
  backToLogin: 'Continuar para login',
  phoneInvalid: 'O número de telefone é inválido.',
  firstName: 'Nome',
  lastName: 'Sobrenome',
  phone: 'Telefone',
  email: 'E-mail',
  createPassword: 'Criar senha',
  confirmPassword: 'Confirmar senha',
  success: {
    redirectIn: 'Você será redirecionado em ',
    seconds: ' segundos',
  },
};

export default signup;
